import throttle from 'lib/function/throttle'
import { useState, useEffect } from 'react'

export default function useHasGotToAnchor(element?: Element | null, rootMargin: number = 0, debounceMs:number = 200): boolean {
  const [hasGotToAnchor, setHasGotToAnchor] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (element) {
        setHasGotToAnchor(element.getBoundingClientRect().top + rootMargin <= 0)
      }
    }

    window.addEventListener('scroll', throttle(handleScroll, debounceMs, { leading: true, trailing: true }))

    return () => {
      window.removeEventListener('scroll', () => throttle(handleScroll, debounceMs))
    }
  }, [element, debounceMs, rootMargin])

  return hasGotToAnchor
}
